'use client'

import { Box } from '@mui/material'
import { useContext, useEffect, useMemo } from 'react'
import {
	getMediaObjectKey,
	// Browse,
	MediaContext
} from '@wolfdanepug/media-service-nextjs'
import { gql, useMutation } from '@apollo/client'
import {
	Logger,
	UpdatePetProfile
	// orange
} from '@wolfdanepug/common-react'
import { getNoImage } from '../utils'
import { mediaPath } from '../constants'

export interface ProfileImageManagerProps {
	profile?: any
	alt?: string
	prefix?: string
}

// the ID is the last UUID in the URL before the file extension
const parseIdFromFileName = (fileName: string) => {
	Logger.log('parseIdFromFileName', fileName)
	if (!fileName) return ''
	const parts: string[] = fileName.split('/')
	return parts[parts.length - 1].split('.')[0]
}

export const ProfileImageManager = ({
	profile,
	alt = '',
	prefix = 'media'
}: ProfileImageManagerProps) => {
	const { useMediaState } = useContext(MediaContext)
	const { uploadedUrls } = useMediaState()
	const [saveProfileImage] = useMutation(gql(UpdatePetProfile))

	const image = useMemo(() => {
		if (uploadedUrls.length > 0) {
			return `${mediaPath}/${uploadedUrls[0]}`
		} else if (profile?.image) {
			return `${mediaPath}/${getMediaObjectKey(profile.image)}`
		}
		return getNoImage(0)
	}, [profile.image, uploadedUrls])

	const handleUrls = (urls: string[]) => {
		if (uploadedUrls.length > 0) {
			urls.forEach((url: string) => {
				const id = parseIdFromFileName(url)
				saveProfileImage({
					variables: {
						input: {
							id: profile.id,
							image: id
						}
					},
					refetchQueries: ['GetPetProfile']
				})
			})
		}
	}

	useEffect(() => {
		handleUrls(uploadedUrls)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [uploadedUrls])

	return (
		<Box sx={styles.root}>
			{/* <Browse sx={styles.action} autoInit>
				<Box
					sx={{ p: 1, backgroundColor: orange, borderRadius: 1, color: '#fff' }}
					component="span"
				>
					Change Image
				</Box>
			</Browse> */}

			<Box component={'img'} src={image} sx={styles.image} alt={alt} />
		</Box>
	)
}

const styles = {
	root: {
		position: 'relative'
	},
	action: {
		position: 'absolute',
		display: 'flex',
		alignItems: {
			xs: 'flex-start',
			md: 'flex-end'
		},
		p: 2,
		top: 0,
		left: 0,
		width: '100%',
		height: '100%',
		borderRadius: 0,
		zIndex: 10,
		backgroundColor: 'rgba(255,255,255,0.5)',
		// color: '#fff',
		opacity: 0,
		'&:hover': {
			backgroundColor: 'rgba(255,255,255,0.5)',
			opacity: 1
		},
		'&:active': {
			backgroundColor: 'rgba(255,255,255,0.7)'
		},
		'&:focus': {
			backgroundColor: 'rgba(255,255,255,0.7)'
		}
	},
	image: {
		float: 'left',
		height: {
			xs: 150,
			md: 200
		},
		width: {
			xs: 150,
			md: 200
		},
		backgroundPosition: 'center',
		objectFit: 'cover'
	}
}
